<template>
  <div>
    <div class="col-lg-12" style="padding-top: 20px; padding-bottom: 20px">
      <div class="row">
        <modal :show.sync="modals.viewrejectreason" class="modal-eprf" centered>
          <b-card class="card text-center" style="background-color: #f5f6fa; box-shadow: none" border-variant="primary"
            header="REASON FOR DISPUTE" header-bg-variant="primary" header-text-variant="white">
            <template #header>
              <div class="row">
                <div class="col-lg text-left">
                  <h4 class="mb-0">REASON FOR DISPUTE</h4>
                </div>
                <div class="col-lg-3 text-right" style="padding-bottom: 10px">
                  <base-button class="btn-icon btn-cancel btn-round btn-sm">
                    <i style="
                        transform: translate(-50%, -50%);
                        color: white;
                        font-weight: 900;
                        font-size: 12px;
                      " class="tim-icons icon-simple-remove" @click="modals.viewrejectreason = false"></i>
                  </base-button>
                </div>
              </div>
            </template>

            <div class="row">
              <div class="col-lg-12">
                <textarea type="textarea" placeholder="Reason for rejection..." v-model="reason"
                  :class="{ textarea: true }" disabled></textarea>
              </div>
            </div>
          </b-card>
        </modal>
        <div class="col-lg-2">
          <base-button type="primary" v-on:click="getReferenceNo()">
            + Request Job</base-button>
        </div>
        <div class="col-lg-2">
          <el-select placeholder="Select status" v-model="selects.status" @change="getData()" filterable>
            <el-option v-for="option in selects.statuses" class="select-info custom-option" :value="option.value"
              :label="option.label" :key="option.value"></el-option>
          </el-select>
        </div>
        <div class="col-lg-3 text-left">
          <div style="display: flex; flex-direction: row; height: 80%">
            <div style="width: 8px; height: 80%; background-color: #0baa00"></div>
            &nbsp;
            <p style="margin: 10px; color: #A5A5A5">Completed</p>
            &nbsp;
            <div style="width: 8px; height: 80%; background-color: #ff9900"></div>
            &nbsp;
            <p style="margin: 10px; color: #A5A5A5">Action Required</p>
          </div>
        </div>
        <div class="col-lg"></div>
        <div class="col-lg-2">
          <!-- <base-input> -->
          <el-input type="search" class="mb-3 search-input" prefix-icon="el-icon-search"
            placeholder="Search Job, Cust..." v-model="searchQuery" aria-controls="datatables"></el-input>
          <!-- </base-input> -->
        </div>
      </div>
    </div>

    <div class="col-lg-12">
      <div class="row">
        <div class="col-lg-12">
          <card class="card-eprf">
            <div id="tableku" v-if="this.load == false">
              <el-table :data="queriedData" style="width: 100%; color: #A5A5A5" height="700" :header-cell-style="{
                background: 'transparent',
                color: 'black',
              }" class="custom-table">
                <el-table-column :min-width="200" align="center" prop="jobno" label="REFERENCE NO">
                  <div slot-scope="{ row }">
                    <p class="job-no-title" style="color: #358CCB" @click="getJobPage(row)">
                      {{ row.jobno }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column :min-width="200" sortable align="center" prop="datecreated" label="DATE CREATED">
                  <div slot-scope="{ row }">
                      {{ moment(row.datecreated).format(
                        "DD MMM YYYY"
                      ) }}</div>
                </el-table-column>
                <el-table-column :min-width="200" align="center" prop="jobstatus" label="JOB STATUS">
                  <div slot-scope="{ row }">
                    <p style="color: #0baa00" v-if="
                      row.jobstatus == 'Completed' ||
                      row.jobstatus == 'Accepted'
                    ">
                      {{ row.jobstatus }}
                    </p>
                    <p style="color: #ff0000" v-else-if="row.jobstatus == 'Pending'">
                      {{ row.jobstatus }}
                    </p>
                    <p class="job-no-title2" style="color: #ff0000" v-else-if="row.jobstatus == 'Disputed'"
                      @click="getDisputeReason(row, 'job')">
                      {{ row.jobstatus }}
                    </p>

                    <p v-else style="color: #A5A5A5">
                      {{ row.jobstatus }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column :min-width="200" align="center" prop="quotation" label="QUOTATION">
                  <div slot-scope="{ row }">
                    <p style="color: #ff0000" v-if="row.quotation.toLowerCase() === 'pending'">
                      {{ row.quotation }}
                    </p>

                    <p class="link" @click="getReview(row)" style="color: #ffa827" v-else-if="
                      row.quotation.toLowerCase() === 'ready to review'
                    ">
                      {{ row.quotation }}
                    </p>

                    <p style="color: #0baa00" v-else-if="row.quotation.toLowerCase() === 'completed'">
                      {{ row.quotation }}
                    </p>

                    <p v-else style="color: #A5A5A5">
                      {{ row.quotation }}
                    </p>
                  </div>
                </el-table-column>
                <el-table-column :min-width="200" sortable align="center" prop="collectiondate" label="COLLECTION DATE">
                  <div slot-scope="{ row }">
                      {{ moment(row.collectiondate).format(
                        "DD MMM YYYY"
                      ) }}</div>
                </el-table-column>
                <!-- <el-table-column v-for="column in joblist" :key="column.label" :prop="column.prop" :label="column.label"
                  align="center" :min-width="200">
                </el-table-column> -->
                <el-table-column :min-width="200" align="center" prop="do" label="WDO">
                  <div slot-scope="{ row }">
                    <p style="color: #ff0000" v-if="row.do.toLowerCase() === 'pending'">
                      {{ row.do }}
                    </p>
                    <p style="color: #0baa00" v-else-if="row.do.toLowerCase() === 'completed'">
                      {{ row.do }}
                    </p>

                    <p v-else style="color: #A5A5A5">
                      {{ row.do }}
                    </p>
                  </div>
                </el-table-column>

                <el-table-column :min-width="200" align="center" prop="invoice" label="INVOICE">
                  <div slot-scope="{ row }">
                    <p style="color: #ff0000" v-if="row.invoice.toLowerCase() === 'pending'">
                      {{ row.invoice }}
                    </p>
                    <p style="color: #0baa00" v-else-if="row.invoice.toLowerCase() === 'completed'">
                      {{ row.invoice }}
                    </p>

                    <p v-else style="color: #A5A5A5">
                      {{ row.invoice }}
                    </p>
                  </div>
                </el-table-column>
              </el-table>
            </div>
            <div class="d-flex justify-content-center spinner" v-if="load">
              <circle-8></circle-8>
            </div>
          </card>
          <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
            <el-select v-model="pagination.perPage" placeholder="Per page">
              <el-option class="select-primary" v-for="item in pagination.perPageOptions" :key="item" :label="item"
                :value="item"></el-option>
            </el-select>

            <base-pagination class="pagination-no-border" v-model="pagination.currentPage"
              :per-page="pagination.perPage" :total="total"></base-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Alert,
  Select,
  Option,
  DatePicker,
  Table,
  TableColumn,
} from "element-ui";
import swal from "sweetalert2";
import { Circle8 } from "vue-loading-spinner";
import util from "../../../util/util";
import Card from "../../../components/Cards/Card.vue";
import {
  Modal,
  ImageUpload,
  BasePagination,
  BaseSwitch,
} from "../../../../src/components";
import moment from "moment";
import Fuse from "fuse.js";
import { debounce } from "src/util/debounce";
import { BCard } from "bootstrap-vue";

export default {
  name: "LandRequest",

  components: {
    Card,
    Modal,
    ImageUpload,
    [DatePicker.name]: DatePicker,
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    BasePagination,
    BaseSwitch,
    Circle8,
    [Select.name]: Select,
    [Option.name]: Option,
    BCard,
  },

  data() {
    return {
      reason: "",
      modals: {
        viewrejectreason: false,
      },
      referenceno: "",
      wastejobid: 0,

      selectedFileName: "",
      allfilename: [],
      tableDatas: [
        {
          jobno: "NPV211028002",
          datecreated: "14 Nov 2023",
          quotation: "Ready to Review",
          collectiondate: "15 Nov 2023",
          invoice: "Complete",
          do: "Complete",
          wdr: "-",
          waste: "-",
          labreport: "-",
        },
        {
          jobno: "NPV211028002",
          datecreated: "14 Nov 2023",
          quotation: "Complete",
          collectiondate: "14 Nov 2023",
          invoice: "Pending",
          do: "Complete",
          wdr: "-",
          waste: "In PRF",
          labreport: "Complete",
        },
        {
          jobno: "NPV211028002",
          datecreated: "14 Nov 2023",
          quotation: "Complete",
          collectiondate: "14 Nov 2023",
          invoice: "-",
          do: "Pending",
          wdr: "Complete",
          waste: "In PRF",
          labreport: "N/A",
        },
        {
          jobno: "NPV211028002",
          datecreated: "14 Nov 2023",
          quotation: "Complete",
          collectiondate: "14 Nov 2023",
          invoice: "-",
          do: "Complete",
          wdr: "Pending",
          waste: "In PRF",
          labreport: "N/A",
        },
        {
          jobno: "NPV211028002",
          datecreated: "14 Nov 2023",
          quotation: "Complete",
          collectiondate: "14 Nov 2023",
          invoice: "-",
          do: "Pending",
          wdr: "-",
          waste: "In PRF",
          labreport: "Pending",
        },
        {
          jobno: "NPV211028002",
          datecreated: "14 Nov 2023",
          quotation: "Ready to Review",
          collectiondate: "14 Nov 2023",
          invoice: "-",
          do: "Complete",
          wdr: "-",
          waste: "In PRF",
          labreport: "N/A",
        },
        {
          jobno: "NPV211028002",
          datecreated: "14 Nov 2023",
          quotation: "Ready to Review",
          collectiondate: "14 Nov 2023",
          invoice: "-",
          do: "Complete",
          wdr: "-",
          waste: "In PRF",
          labreport: "N/A",
        },
        {
          jobno: "NPV211028002",
          datecreated: "14 Nov 2023",
          quotation: "Ready to Review",
          collectiondate: "14 Nov 2023",
          invoice: "-",
          do: "Complete",
          wdr: "-",
          waste: "In PRF",
          labreport: "N/A",
        },
        {
          jobno: "NPV211028002",
          datecreated: "14 Nov 2023",
          quotation: "Ready to Review",
          collectiondate: "14 Nov 2023",
          invoice: "-",
          do: "Complete",
          wdr: "-",
          waste: "In PRF",
          labreport: "N/A",
        },
        {
          jobno: "NPV211028002",
          datecreated: "14 Nov 2023",
          quotation: "Ready to Review",
          collectiondate: "14 Nov 2023",
          invoice: "-",
          do: "Complete",
          wdr: "-",
          waste: "In PRF",
          labreport: "N/A",
        },
      ],

      load: false,
      jobnum: "",

      jobno: [
        {
          prop: "jobno",
          label: "REFERENCE NO",
        },
      ],
      joblist: [
        {
          prop: "collectiondate",
          label: "COLLECTION DATE",
        },
      ],

      selects: {
        assigner: "",
        assigners: [
          { value: "00", label: "All" },
          { value: "01", label: "Yahya Abd Rahman" },
          { value: "02", label: "Ikhwan Ayub" },
          { value: "03", label: "Haziq Haikal" },
        ],

        type: "",
        types: [
          { value: "00", label: "All" },
          { value: "01", label: "Waste" },
          { value: "02", label: "Product" },
        ],
        status: "",
        statuses: [],
      },

      temp: [],
      searchQuery: "",
      searchedData: [],
      fuseSearch: null,
      currentRow: "",
      pagination: {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [10, 20, 30, 50],
        total: 0,
      },
    };
  },
  methods: {
    sortListMethod(a, b) {
      return b - a
    },
    getDisputeReason(row, flag) {
      console.log(row);
      if (flag == "quo") {
        this.reason = row.disputereason;
        this.modals.viewrejectreason = true;
      }
      if (flag == "job") {
        this.reason = row.jobdisputereason;
        this.modals.viewrejectreason = true;
      }
    },
    getStatus() {
      this.selects.statuses = [];

      this.$http.get(":10001/api/v1/incoming/status").then((res) => {
        if (!res.error) {
          let response = res.message;

          for (var i = 0; i < response.length; i++) {
            let obj = {
              label: response[i].name,
              value: response[i].id,
            };
            this.selects.statuses.push(obj);
          }
        }
      });
    },
    camelCase(str) {
      if (str != "") {
        var splitStr = str.toLowerCase().split(" ");
        for (var i = 0; i < splitStr.length; i++) {
          // You do not need to check if i is larger than splitStr length, as your for does that for you
          // Assign it back to the array
          splitStr[i] =
            splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
        }
        // Directly return the joined string
        return splitStr.join(" ");
      }
    },

    getReview(data) {
      this.jobnum = data.jobno;
      this.$router.push("/Land/Review/" + this.jobnum);
    },

    getReferenceNo() {
      this.$http.get(":10001/api/v1/incoming/generate").then((res) => {
        if (!res.error) {
          let response = res.message;

          this.referenceno = response.reference_no;
          this.wastejobid = response.waste_job_id;

          this.$router.push("/Land/RequestJob/" + this.referenceno + "/add");
        }
      });
    },

    getJobPage(data) {
      console.log(data);
      this.jobnum = data.jobno;
      if (data.jobstatus.toUpperCase() == "DRAFT") {
        this.$router.push("/Land/RequestJob/" + this.jobnum + "/edit");
      } else {
        this.$router.push("/Land/RequestJob/" + this.jobnum + "/view");
      }
    },

    getData() {
      this.load = true;
      this.tableDatas = [];

      this.$http
        .get(":10001/api/v1/incoming?status=" + this.selects.status)
        .then((res) => {
          if (!res.error) {
            let response = res.message;

            for (var i = 0; i < response.length; i++) {
              let obj = {
                jobno: response[i].reference_no,
                datecreated: response[i].created_at,
                // moment(response[i].created_at).format(
                // "DD-MM-YYYY"
                // ),
                jobstatus: this.camelCase(response[i].waste_job_status_text),
                quotation: this.camelCase(response[i].quotation_status_text),
                collectiondate: 
                // moment(
                  response[i].arrival_eta
                // ).format(
                  // "DD-MM-YYYY"
                // )
                ,
                do: this.camelCase(response[i].waste_disposal_status_text),
                labreport: this.camelCase(response[i].lab_report_status_text),
                invoice: this.camelCase(response[i].invoice_status_text),
                jobdisputereason: response[i].dispute_reason,
              };
              this.tableDatas.push(obj);
              this.temp.push(obj);
            }

            //for checking only
            let obj2 = {
              jobno: "NGL240124162",
              datecreated: "",
              quotation: "Submitted",
              collectiondate: "",
              invoice: 5,
              wdr: "-",
              waste: 7,
              labreport: 7,
            };
            this.tableDatas.push(obj2);
            this.load = false;
          }
        });
    },
  },
  created() {
    this.getStatus();
    this.getData();
  },
  computed: {
    queriedData() {
      let result = this.tableDatas;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableDatas.length;
    },
  },
  watch: {
    searchQuery: debounce(function (search) {
      if (search != "") {
        this.tableDatas = this.temp.filter((value) =>
          value.jobno.toLowerCase().includes(search.toLowerCase())
        );
      } else {
        this.tableDatas = this.temp;
      }
    }, 500),
  },
  mounted() {
    this.fuseSearch = new Fuse(this.tableDatas, {
      keys: ["jobno"],
      threshold: 1.0,
    });
  },
};
</script>
<style>
.custom-button {
  background-color: transparent;
  border: none;
  border-bottom: 1px solid lightgray;
}

.custom-dropdown .el-select-dropdown {
  background-color: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.job-no-title {
  color: #358CCB;
  text-decoration: none;
  cursor: pointer;
}

.job-no-title:hover {
  color: #358CCB;
  text-decoration: underline;
  cursor: pointer;
}

.link {
  cursor: pointer;
}

.link:hover {
  text-decoration: underline;
  cursor: pointer;
}

.job-no-title2 {
  color: #A5A5A5;
  text-decoration: none;
}

.job-no-title2:hover {
  color: #A5A5A5;
  text-decoration: underline;
  cursor: pointer;
}

textarea {
  width: 100%;
  height: 350px;
  padding: 12px 20px;
  box-sizing: border-box;
  border: 1px solid #2b3553;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  resize: none;
  /* color: #1d253b; */
}

textarea:focus {
  outline: none !important;
  border: 1px solid #1d8cf8;
  transition: color 0.3s ease-in-out, border-color 0.3s ease-in-out,
    background-color 0.3s ease-in-out;
}
</style>
